<template>
  <div class="main-page">
    <Menu
      title="好差评"
      :home="true"
    />
    <div class="container-flex  ">
      <div class="person-info ">
        <div class="lp-question">
          <div class="lp-question--title">
            <strong>请您填写真实信息</strong>
          </div>
          <div class="cell-form">
            <div class="lp-question-form">
              <div class="cells-title">姓名</div>
              <div class="cells-bd">
                <div>
                  <input
                    type="text"
                    placeholder="姓名"
                    v-model="username"
                    @blur="checkname"
                    class="lp-question-input"
                  />
                </div>
                <div
                  class="errorinfo"
                  v-if="errinfo.sidName"
                >！{{errinfo.sidName}}</div>
              </div>
            </div>
            <div class="lp-question-form">
              <div class="cells-title">证件类型</div>
              <div class="cells-bd">
                <div>
                  <select
                    v-model="idTyped"
                    class="lp-question-input"
                  >
                    <option
                      v-for="(item,index) in IdType"
                      :key="'IdType'+index"
                      :value="item.id"
                    >
                      {{ item.value }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="lp-question-form">
              <div class="cells-title">证件号码</div>
              <div class="cells-bd">
                <div>
                  <input
                    type="text"
                    placeholder="请输入证件号码"
                    v-model="sqridcard"
                    @blur="checkcard"
                    class="lp-question-input"
                  />
                </div>
                <div
                  class="errorinfo"
                  v-if="errinfo.sidCard"
                >！{{errinfo.sidCard}}</div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="button"
          :class="isName&&isIdType&&isSqridcard ? 'seed' : ''"
          @click="submit"
        >下一步</div>
      </div>

    </div>
  </div>
</template>

<script>
import Menu from '../../components/Menu'
import { IdType } from './js/config'
import idCard from 'idcard'
export default {
  components: {
    Menu
  },

  data () {
    return {
      IdType,
      username: '',
      idTyped: '',
      sqridcard: '',
      errinfo: {
        sidName: '',
        sidCard: ''
      },
      isName: false,
      isIdType: true,
      isSqridcard: false
    }
  },
  mounted () {
    this.idTyped = this.IdType[1].id
  },
  methods: {
    checkname () {
      if (!this.username.length) {
        this.errinfo.sidName = '请填写姓名'
      } else {
        this.isName = true
      }
    },
    checkcard () {
      if (!this.sqridcard.length) {
        this.errinfo.sidCard = '请输入证件号码'
      } else {
        this.isSqridcard = true
      }
    },
    submit () {
      this.$router.push('/officeevalution')
    }

  },
  watch: {
    username (val) {
      if (val.length) {
        this.errinfo.sidName = ''
      }
      if (!val.length) {
        this.errinfo.sidName = '请输入姓名'
      }
    },
    idTyped (val, oldval) {
      if (val !== oldval) {
        this.sqridcard = ''
      }
    },
    sqridcard (val) {
      val = val.replace(' ', '')
      let checknum = /^[0-9Xx]*$/
      for (let char of this.sqridcard) {
        if (!checknum.test(char)) {
          this.sqridcard = this.sqridcard.replace(char, '')
        }
      }
      if (val.length) {
        if (this.idTyped === '111' || this.idTyped === '112' || this.idTyped === '113') {
          const cardInfo = idCard.info(val)
          if (!cardInfo.valid) {
            this.errinfo.sidCard = '身份证号格式错误'
          } else {
            this.gender = cardInfo.gender === 'F' ? 1 : 2
            this.errinfo.sidCard = ''
          }
        } else {
          this.errinfo.sidCard = ''
        }
      } else {
        this.errinfo.sidCard = ''
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.person-info
  margin 0.6rem auto 40vh auto
  .lp-question-input
    option
      color #333
  .errorinfo
    position absolute
    bottom -0.12rem
    line-height 1.1
    font-size 0.2rem
    color red
  .button
    display block
    margin 0.6rem auto 0 auto
    width 2.78rem
    text-align center
    height 0.9rem
    line-height 0.9rem
    border 0
    color #fff
    background #ccc
    border-radius 0.1rem
    font-size 0.28rem
    &.seed
      background #fc9d0b
</style>
